import { jsx } from "@emotion/react/jsx-runtime";
import _styled from "@emotion/styled/base";
import { generateUniqueId, useThemeProps, mergeProps } from "@wsui/base";
import { useField } from "formik";
import { useState } from "react";
import clsx from "clsx";
import formFieldContext from "./formFieldContext.mjs";
const FormFieldWrapperRoot = /* @__PURE__ */_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ewwp2ey0"
} : {
  target: "ewwp2ey0",
  label: "FormFieldWrapperRoot"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
function FormFieldWrapper(props) {
  let {
    children,
    controlProps,
    description,
    descriptionProps,
    errorProps,
    hideLabel = false,
    id,
    label,
    labelProps,
    multiple,
    name,
    required,
    type,
    value,
    wrapperProps,
    className,
    ...restProps
  } = props;
  let [defaultId] = useState(() => `form-field-${generateUniqueId()}`);
  id = id ?? defaultId;
  const [inputProps, meta, helpers] = useField({
    name,
    multiple,
    type,
    value
  });
  wrapperProps = useThemeProps({
    props: wrapperProps,
    name: "FormFieldWrapper"
  });
  const ownerState = mergeProps({
    controlProps: {
      required,
      "aria-required": required,
      "aria-invalid": !!(meta.touched && meta.error),
      // We use clsx here to make a space-separated list of references
      "aria-describedby": clsx(description && `${id}-description`, `${id}-errors`)
    }
  }, {
    controlProps,
    description,
    descriptionProps,
    errorProps,
    helpers,
    hideLabel,
    id,
    inputProps,
    label,
    labelProps,
    meta,
    multiple,
    name,
    required,
    type,
    wrapperProps,
    ...restProps
  });
  return /* @__PURE__ */jsx(FormFieldWrapperRoot, {
    className,
    ownerState,
    ...wrapperProps,
    children: /* @__PURE__ */jsx(formFieldContext.Provider, {
      value: ownerState,
      children: children(ownerState)
    })
  });
}
export { FormFieldWrapper as default };